'use strict'

const get_ = require('lodash/get')
const maybe = require('folktale/maybe')

const { recordStoreServiceCreator } = require('../record-store')
const queryResults = require('../helpers/queryResults')

const createRecordStoreService = ({
  wixDataProxy,
  controllerConfig,
  datasetType,
  dynamicPagesData,
  Raven,
  getSchema
}) => {
  const datasetConfig = maybe
    .fromNullable(controllerConfig)
    .chain(({ dataset }) => maybe.fromNullable(dataset))
  const collectionName = datasetConfig.chain(({ collectionName }) =>
    maybe.fromNullable(collectionName)
  )

  return collectionName.map(mainCollectionName => {
    const includes = get_(controllerConfig, ['dataset', 'includes'])
    const readWriteType = get_(controllerConfig, ['dataset', 'readWriteType'])

    return recordStoreServiceCreator({
      wixDataProxy,
      mainCollectionName,
      includes,
      readWriteType,
      datasetType,
      dynamicPagesData,
      Raven,
      getSchema
    })
  })
}

const createRecordStoreInstance = (
  recordStoreService,
  getConfig,
  getPageSize,
  prefetchedData,
  controllerId,
  filterResolver
) => byRefField => {
  const config = getConfig()
  const pageSize = getPageSize()
  const sort = config.sort

  return recordStoreService.apply(
    maybe.fromNullable(byRefField).matchWith({
      Nothing: () =>
        filterResolver(config.filter).map(filter => ({
          pageSize,
          sort,
          filter,
          seed: queryResults.fromWixDataQueryResults(prefetchedData),
          controllerId
        })),
      Just: ({ value }) =>
        maybe.Just({
          pageSize,
          sort: null,
          filter: null,
          seed: queryResults.Empty(),
          controllerId,
          byRefField
        })
    })
  )
}

module.exports = { createRecordStoreService, createRecordStoreInstance }



// WEBPACK FOOTER //
// ./dataset-controller/recordStoreService.js